import { render, staticRenderFns } from "./ProjectTemplateNotificationList.vue?vue&type=template&id=6af5d0e3&"
import script from "./ProjectTemplateNotificationList.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplateNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports